if (!customElements.get('momento-filter-comparison')) {
  class MomentoFilterComparison extends HTMLElement {
    connectedCallback() {
      this.initialize();
    }

    initialize() {
      if (this.initialized) return;
      this.initialized = true;

      this.preview = this.querySelector('.momento-filter-comparison__preview');
      this.filteredImage = this.querySelector('.momento-filter-comparison__image--filtered');
      this.originalImage = this.querySelector('.momento-filter-comparison__image--original');
      this.tabs = [...this.querySelectorAll('.momento-filter-comparison__tab')];
      this.position = 50;
      this.dragging = false;

      this.sources = {
        original: this.dataset.originalSrc,
        classic: this.dataset.classicSrc,
        film: this.dataset.filmSrc,
        'black-white': this.dataset.blackWhiteSrc,
      };

      this.preloads = Object.fromEntries(
        Object.entries(this.sources).map(([name, src]) => [name, this.preload(src)])
      );

      this.originalImage.src = this.sources.original;
      this.filteredImage.src = this.sources.classic;

      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.selectFilter(tab)));
      this.preview.addEventListener('pointerdown', (event) => this.startDrag(event));
      this.preview.addEventListener('pointermove', (event) => this.moveDrag(event));
      this.preview.addEventListener('pointerup', (event) => this.endDrag(event));
      this.preview.addEventListener('pointercancel', (event) => this.endDrag(event));
      this.preview.addEventListener('keydown', (event) => this.handleKeydown(event));
    }

    preload(src) {
      const image = new Image();
      image.src = src;
      return image.decode().catch(() => undefined);
    }

    async selectFilter(tab) {
      const filter = tab.dataset.filter;
      await this.preloads[filter];

      this.filteredImage.src = this.sources[filter];
      this.filteredImage.alt = `${tab.textContent.trim()} Momento filter preview`;
      this.tabs.forEach((button) => {
        const active = button === tab;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    }

    startDrag(event) {
      if (event.button !== 0) return;
      this.dragging = true;
      this.bounds = this.preview.getBoundingClientRect();
      this.preview.setPointerCapture(event.pointerId);
      this.updateFromPointer(event.clientX);
    }

    moveDrag(event) {
      if (!this.dragging) return;
      this.updateFromPointer(event.clientX);
    }

    endDrag(event) {
      if (!this.dragging) return;
      this.dragging = false;
      if (this.preview.hasPointerCapture(event.pointerId)) {
        this.preview.releasePointerCapture(event.pointerId);
      }
    }

    updateFromPointer(clientX) {
      const percent = ((clientX - this.bounds.left) / this.bounds.width) * 100;
      this.setPosition(percent);
    }

    handleKeydown(event) {
      let next = this.position;

      if (event.key === 'ArrowLeft') next -= 2;
      else if (event.key === 'ArrowRight') next += 2;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = 100;
      else return;

      event.preventDefault();
      this.setPosition(next);
    }

    setPosition(position) {
      this.position = Math.min(100, Math.max(0, position));
      const rounded = Math.round(this.position);
      this.preview.style.setProperty('--momento-filter-position', `${this.position}%`);
      this.preview.setAttribute('aria-valuenow', String(rounded));
      this.preview.setAttribute(
        'aria-valuetext',
        `${100 - rounded} percent filtered and ${rounded} percent original`
      );
    }
  }

  customElements.define('momento-filter-comparison', MomentoFilterComparison);
}
